(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-list-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-list-item.js');
'use strict';

const Dots = svs.ui.ReactDots;
const {
  Card,
  CardBody,
  CardHeader
} = svs.ui.ReactCard;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  InlineMessage
} = svs.components.tb_ui_react.inlineMessage;
const {
  ActiveMemberPanel,
  InactiveMemberPanel,
  LeaveTeamPopoverItem,
  MemberPopover,
  TeamBalance,
  TerminateTeamPopoverItem
} = svs.arena.pages.teams.components;

const clearUrlParam = paramToClear => {
  svs.utils.url.refreshQueryString();
  const {
    [paramToClear]: currentParamToClear
  } = svs.utils.url.queryString;
  if (currentParamToClear) {
    let targetString = '';
    let delim = '?';
    for (const param in svs.utils.url.queryString) {
      if (param !== paramToClear) {
        targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
        delim = '&';
      }
    }
    window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
    svs.utils.url.refreshQueryString();
  }
};
const TeamsListItem = _ref => {
  let {
    isPreselected,
    team
  } = _ref;
  const cardWrapperRef = React.useRef();
  const cardTopRef = React.useRef();

  if (isPreselected && cardTopRef.current) {
    var _cardTopRef$current;
    clearUrlParam('syndicateId');
    window.onload = (_cardTopRef$current = cardTopRef.current) === null || _cardTopRef$current === void 0 ? void 0 : _cardTopRef$current.scrollIntoView();
  }
  return React.createElement("div", {
    ref: cardWrapperRef
  }, React.createElement("div", {
    defer: true,
    ref: cardTopRef
  }, " "), React.createElement(Card, {
    branding: "tur",
    className: "margin-bottom-2"
  }, React.createElement(CardHeader, {
    className: "base-card-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center"
  }, React.createElement("div", {
    className: "col-xs-1"
  }), React.createElement("div", {
    className: "col-xs-10 f-center"
  }, React.createElement("h2", {
    className: "h2 margin-bottom margin-top-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, team === null || team === void 0 ? void 0 : team.syndicateName))), React.createElement("div", {
    className: "col-xs-1 u-flex u-flex-justify-content-end"
  }, React.createElement(MemberPopover, null, (team === null || team === void 0 ? void 0 : team.isLeader) && React.createElement(TerminateTeamPopoverItem, {
    amount: team === null || team === void 0 ? void 0 : team.memberBalance,
    teamId: team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  }, "Avsluta lag"), !(team !== null && team !== void 0 && team.isLeader) && React.createElement(LeaveTeamPopoverItem, {
    memberBalance: team === null || team === void 0 ? void 0 : team.memberBalance,
    teamId: team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  }, "L\xE4mna lag"))))), React.createElement(Dots, {
    branding: "arena"
  }), React.createElement(CardBody, {
    className: "padding-h-0"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    className: "align-center"
  }, (team === null || team === void 0 ? void 0 : team.tooFewMembers) && React.createElement("div", {
    className: "padding-h-1"
  }, React.createElement(InlineMessage, {
    icon: "players"
  }, "Laget beh\xF6ver ha minst 2 aktiva medlemmar f\xF6r att ni skall kunna spela.")), !(team !== null && team !== void 0 && team.tooFewMembers) && React.createElement(TeamBalance, {
    memberBalance: team === null || team === void 0 ? void 0 : team.memberBalance,
    playableAmount: team === null || team === void 0 ? void 0 : team.playableAmount
  }))), !(team !== null && team !== void 0 && team.isInactive) && React.createElement(ActiveMemberPanel, {
    team: team
  }), (team === null || team === void 0 ? void 0 : team.isInactive) && React.createElement(InactiveMemberPanel, {
    teamId: team === null || team === void 0 ? void 0 : team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  })))));
};
svs.arena.pages.teams.components.TeamsListItem = TeamsListItem;

 })(window);